"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("../_util/useConfig"));
var Button = function (props) {
    // 解析props属性
    var onClick = props.onClick, loading = props.loading, disabled = props.disabled, className = props.className, children = props.children;
    // 获取样式的通用前缀
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    return (react_1.default.createElement("button", { className: (0, classnames_1.default)(
        // 所有组件样式，第一位来自传入的className，第二位为此组件加了前缀的样式
        className, "".concat(classPrefix, "-button")), disabled: disabled || loading, onClick: onClick }, children));
};
// 定义组件displayName
Button.displayName = 'Button';
exports.default = Button;
//# sourceMappingURL=Button.js.map